import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";


@Module
export default class panelSTModule extends VuexModule  {



  panelst = {}

  panelsstPagination = {
    pagination: null,
    loading: true,
    error: null,
  };


  panelsstFilters = {
    search: "",
    page: 1,
    searchString: "",
    limit: parseInt(process.env.VUE_APP_PAGINATION || "20"),
  };

  panelsstFilesFilters = {
    search: "",
    page: 1,
    searchString: "",
    limit: parseInt(process.env.VUE_APP_PAGINATION || "20"),
  };




  /* --- GETTERS --- */

  get getPanelST() {
    return this.panelst;
  }

  get getPanelSTs(): any {
    return this.panelsstPagination;
  }

  get getPanelSTsPagination() {
    // //console.log('kk',this.clientsPagination);
    return this.panelsstPagination;
  }

  get getPanelSTsFilters() {
    return this.panelsstFilters;
  }

  get getPagePanelSTs() {
    return this.panelsstFilters.page;
  }


  /* --- MUTATIONS --- */


  @Mutation
  [Mutations.SET_DERIVACIONES_ST_PAGINATION](payload) {
    this.panelsstPagination = payload;
  }

  @Mutation
  [Mutations.CLEAR_DERIVACIONES_ST_FILTERS](payload) {
    this.panelsstFilters = {
      search: "",
      page: 1,
      searchString: "",
      limit: parseInt(process.env.VUE_APP_PAGINATION || "20"),
    };
  }
 
  @Mutation
  [Mutations.SET_PAGE_PAGINATION_DERIVACIONES_ST](payload) {
    this.panelsstFilters.page = payload;
  }

  @Mutation
  [Mutations.SET_DERIVACIONES_ST](payload) {
    this.panelst = payload
  }


  @Mutation
  [Mutations.FILTER_DERIVACIONES_ST](payload) {
    // //console.log('FILTERmutation',payload);
    this.panelsstFilters.searchString = payload
  }



  @Action
  [Actions.CLEAR_DERIVACIONES_ST_FILTERS](payload) {
    this.context.commit(Mutations.CLEAR_DERIVACIONES_ST_FILTERS, payload);
  }

  @Action
  [Actions.SET_PAGE_PAGINATIONS_DERIVACIONES_ST](payload) {
    this.context.commit(Mutations.SET_PAGE_PAGINATION_DERIVACIONES_ST, payload.page);
    this.context.dispatch(payload.getAction);
    //console.log('SET_PAGE_PAGINATIONS_CLIENTS',payload.getAction)
  }

  @Action({ rawError: true })
  [Actions.FILTER_DERIVACIONES_ST](payload) {
    // this.context.commit(Mutations.SET_LOADING_TRUE);
    this.context.commit(Mutations.FILTER_DERIVACIONES_ST, payload);
    this.context.dispatch(Actions.GET_DERIVACIONES_ST,payload)
  }


  /* --- ACTIONS --- */

  @Action({ rawError: true })
  [Actions.REQUEST_DERIVACIONES_ST](payload) {
    const {id, tag} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.post(`/st`, payload)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_ST);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_DERIVACIONES_ST_TAG](payload) {
    const {id, tag} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.put(`/st/tag/${id}`, payload)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_ST);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }


  @Action({ rawError: true })
  [Actions.ASSIGN_DERIVACIONES_ST](payload) {
    const {id} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.put(`/st/assign/${id}`, payload)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_ST);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.UPDATE_DERIVACIONES_ST_PROVIDER](payload) {
    const {id, tag} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.put(`/st/assign/${id}`, payload)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_ST);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.SET_OFFER_ST](payload) {
    const {id, tag} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.put(`/st/offerst/${id}`, payload)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_ST);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }

  @Action({ rawError: true })
  [Actions.DELETE_DERIVACIONES_ST](payload) {
    const {id} = payload;
   
    return new Promise((resolve, reject) => {
      ApiService.delete(`/st/delete/${id}`)
        .then(({ data }) => {
          this.context.dispatch(Actions.GET_DERIVACIONES_ST);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response.data.errors);
        });
    });
  }


  @Action({ rawError: true })
  [Actions.GET_DERIVACIONES_ST_TO_DOWNLOAD](payload) {
    return new Promise((resolve, reject) => {
    this.panelsstPagination.loading = true;
     return ApiService.get(
      `st/getallrecords?search=${this.panelsstFilesFilters.search}${this.panelsstFilters.searchString}`
    )
      .then(({ data }) => {
        // //console.log('data ', data)
        // this.context.commit(Mutations.SET_CLIENTS, data);
        resolve(data)
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
        reject(resolve)
      });
    })
  }



  @Action({ rawError: true })
  [Actions.GET_DERIVACIONES_ST](payload) {
    this.panelsstPagination.loading = true;
    return ApiService.get(
      `getst?limit=10&page=${this.panelsstFilters.page}&search=${this.panelsstFilters.search}${this.panelsstFilters.searchString}`
      // `customerfiles`
    )
      .then(({ data }) => {
        this.context.commit(Mutations.SET_DERIVACIONES_ST_PAGINATION, {
          pagination: data,
          loading: false,
          error: null,
        });
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
      });
  }

  @Action({ rawError: true })
  [Actions.GET_DERIVACIONES_ST_BY_CUSTOMERFILE_ID](id) {
    this.panelsstPagination.loading = true;
    return new Promise((resolve, reject) => {
    return ApiService.get(
      `st/customerfilesid/${id}`
    )
      .then(({ data }) => {
        this.context.commit(Mutations.SET_DERIVACIONES_ST, data);
        resolve(data)
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data.errors);
        reject(response)
      });
    })
  }

 


}
